import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { shareUrl } from '../utils/shareUrl'

/**
 * Links minted before share.crowds.cl pointed at `admin…/share/:shareId`.
 * They keep working by forwarding there; the page itself now lives on the
 * share site (functions-share/), so this renders nothing.
 */
export default function SharedVideoPage() {
    const { shareId } = useParams()
    useEffect(() => {
        window.location.replace(shareUrl(shareId))
    }, [shareId])
    return null
}
